class CheckoutHelper {
  /*
  returns an 8 digit random number for setting a password
   */

  randomPassword (length, chars) {
    let mask = ''
    let result = ''
    if (chars.indexOf('#') > -1) {
      mask += '0123456789'
      result = mask[Math.round(Math.random() * (mask.length - 1))]
      length--
    }
    if (chars.indexOf('a') > -1) mask += 'abcdefghijklmnopqrstuvwxyz'
    if (chars.indexOf('A') > -1) mask += 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
    for (let i = length; i > 0; --i) result += mask[Math.round(Math.random() * (mask.length - 1))]
    return result
  }
}

export { CheckoutHelper }
